<template>
  <v-flex xs12 sm6 md3>
    <v-text-field
      v-model.trim="searchText"
      :append-outer-icon="'search'"
      label="Wpisz szukaną frazę"
      @click:clear="clearSearch"
      @click:append-outer="searchUser"
      v-on:keyup.enter="searchUser"
      clearable
    ></v-text-field>
  </v-flex>
</template>

<script>
export default {
  name: 'user-search',
  data: () => ({
    searchText: null,
  }),
  methods: {
    searchUser() {
      const { query } = this.$route;
      const newQuery = {
        ...query,
      };
      if (this.searchText) {
        newQuery.search = this.searchText;
        this.$router.push({ path: '/uzytkownicy/1', query: newQuery });
      }
    },
    clearSearch() {
      const { query } = this.$route;
      const newQuery = {
        ...query,
      };
      delete newQuery.search;
      this.$router.push({ path: '/uzytkownicy/1', query: newQuery });
    },
  },
  mounted() {
    const { query } = this.$route;
    this.searchText = query.search;
  },
};
</script>
